import commaNumber from 'comma-number';
import {
  Eye,
  Heart,
  MessageSquareMore,
  Share,
  ThumbsDown,
  ThumbsUp,
  Users,
} from 'lucide-react';
import { cloneElement, type ReactElement } from 'react';

import { Flex } from '@/components/base';
import TooltipV2 from '@/components/Tooltip/TooltipV2';
import useColor from '@/hooks/domain/useColor';

import { ValueWrapper } from '../ValueWrapper';
import { PropertyRowWrapper } from './PropertyRowWrapper';
import type { CommonFieldProps } from './types';

export const EngagementField = (
  props: CommonFieldProps & {
    engagement?: Engagement;
  },
) => {
  if (!props.showFull && !props.engagement) return null;

  return (
    <PropertyRowWrapper {...props} expandable>
      <Flex g={10} className="flex-wrap">
        <EngagementItem
          icon={<MessageSquareMore />}
          label="Comments"
          value={props.engagement?.comment_count}
        />
        <EngagementItem
          icon={<Heart />}
          label="Likes"
          value={props.engagement?.like_count}
        />
        <EngagementItem
          icon={<Share />}
          label="Shares"
          value={props.engagement?.share_count}
        />
        <EngagementItem
          icon={<Users />}
          label="Subscribers"
          value={props.engagement?.subscribe_count}
        />
        <EngagementItem
          icon={<Eye />}
          label="Views"
          value={props.engagement?.view_count}
        />
        <EngagementItem
          icon={<ThumbsUp />}
          label="Up votes"
          value={props.engagement?.votes_up_count}
        />
        <EngagementItem
          icon={<ThumbsDown />}
          label="Down votes"
          value={props.engagement?.votes_down_count}
        />
      </Flex>
    </PropertyRowWrapper>
  );
};

const EngagementItem = ({
  icon,
  label,
  value,
}: {
  icon: ReactElement;
  label: string;
  value?: number;
}) => {
  const color = useColor();
  const clonedIcon = cloneElement(icon, {
    size: '1em',
    color: color.gray600,
  });
  return (
    <TooltipV2 tooltipNode={label}>
      <ValueWrapper>
        <Flex className="text-xs font-medium">{clonedIcon}</Flex>
        <Flex className="text-xs font-medium text-gray-700">
          {value ? commaNumber(value) : '-'}
        </Flex>
      </ValueWrapper>
    </TooltipV2>
  );
};
